import { dictationWordLength, DictationWordTypeEnum } from '@doltech/utils/lib/constants';
import { Instance, types } from 'mobx-state-tree';
import { nanoid } from 'nanoid';

export const DictationWord = types
  .model('DictationWord', {
    key: types.number,
    value: types.string,
    id: types.optional(types.string, nanoid()),
    type: types.enumeration<DictationWordTypeEnum>(
      'DictationWordTypeEnum',
      Object.values(DictationWordTypeEnum)
    ),
  })
  .actions((self) => {
    return {
      toggle() {
        if (self.type === DictationWordTypeEnum.PUNCTUATION) return;

        self.type =
          self.type === DictationWordTypeEnum.TEXT
            ? DictationWordTypeEnum.BLANK
            : DictationWordTypeEnum.TEXT;
      },
    };
  })
  .views((self) => {
    return {
      get isBlank() {
        return self.type === DictationWordTypeEnum.BLANK;
      },
      get length() {
        let length = 0;
        [...self.value].forEach((char) => {
          length += dictationWordLength[char] ?? dictationWordLength.DEFAULT;
        });
        return length;
      },
    };
  });

export interface DictationWordInstance extends Instance<typeof DictationWord> {}
